<mat-form-field>
  <mat-label>{{ 'COMMON.LABEL.TAG' | translate }}</mat-label>
  <mat-select
    [(ngModel)]="selectedTag"
    (ngModelChange)="selectedTagChanged.emit({ selectedTag: $event })"
    class="user-tag-selector">
    <mat-select-trigger>
      <div class="in-select--selected-tag-wrapper" *ngIf="selectedTag; else PlaceholderTag">
        <div class="in-select--selected-tag">
          <mat-icon inline [style.color]="selectedTagAsUserTag.color" class="tags-icon">
            {{ selectedTagAsUserTag.icon }}
          </mat-icon>
          {{ selectedTagAsUserTag.label | translate }}
        </div>
        <mat-icon
          class="in-select--reset-btn"
          inline
          (click)="$event.stopPropagation(); selectedTag = null; selectedTagChanged.emit({ selectedTag: null })">
          close
        </mat-icon>
      </div>
      <ng-template #PlaceholderTag>
        {{ 'COMMON.LABEL.FILTER_BY_TAG' | translate }}
      </ng-template>
    </mat-select-trigger>
    <mat-option *ngFor="let tagViewModel of userTags" [value]="tagViewModel.name">
      <mat-icon inline [style.color]="tagViewModel.color" class="tags-icon">
        {{ tagViewModel.icon }}
      </mat-icon>
      {{ tagViewModel.label | translate }}
    </mat-option>
  </mat-select>
</mat-form-field>
